import axios from "axios";
import baseURL from "./../api";
class DistributorsService {

    getDistributors() {
        return axios.get(`${baseURL}/distributor`);
    }
    registerDistributor(data) {
        return axios.post(`${baseURL}/distributor`,data);
    }
    suspendDistributor(data) {
      return axios.post(`${baseURL}/distributor/suspend`,data);
    }
    resumeDistributor(data) {
      return axios.post(`${baseURL}/distributor/resume`,data);
    }
    deleteDistributorData(id) {
      return axios.delete(`${baseURL}/distributor/${id}`);
    }
    getDistributorDetails(id) {
      return axios.get(`${baseURL}/distributor/${id}`);
  }
  updateDistributor(id,data) {
    return axios.patch(`${baseURL}/distributor/${id}`, data);
  }
  getDistributorUsers(id) {
    return axios.get(`${baseURL}/users/dropdown?customerId=${id}`);
  }
}
export default new DistributorsService();